import { useUsuario } from '../../context/UsuarioContext';
import { useTurnosUsuario } from './useTurnosUsuario';
import { useCancelarTurno } from './useCancelarTurno';
import { filtrarProximos, filtrarPasados } from './MisTurnosUtils';
import ProximosTurnos from './ProximosTurnos';
import TurnosPasados from './TurnosPasados';
import TarjetaCancelar from './TarjetaCancelar';
import './MisTurnos.css';

export default function ContenedorGeneral() {
  const { pacienteId } = useUsuario();
  const { turnos, loading, error, cancelar } = useTurnosUsuario(pacienteId);
  const { cancelTarget, cancelError, isCancelling, handleCancel, confirmCancel, cerrar } = useCancelarTurno(cancelar);

  return (
    <>
      <div className="mis-turnos-header">
        <div>
          <h1>Mis turnos</h1>
          <p className="mis-turnos-muted">Paciente ID: {pacienteId}</p>
        </div>
      </div>

      {loading && <p>Cargando turnos...</p>}
      {error && <p>{error}</p>}

      {!loading && !error && (
        <>
          <ProximosTurnos proximos={filtrarProximos(turnos)} onCancel={handleCancel} />
          <TurnosPasados pasados={filtrarPasados(turnos)} />
        </>
      )}

      <TarjetaCancelar
        turno={cancelTarget}
        onClose={cerrar}
        onConfirm={confirmCancel}
        error={cancelError}
        loading={isCancelling}
      />
    </>
  );
}